{
  "title": "Arcane Lock",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (gold dust worth at least 25 gp, which the spell consumes)",
  "duration": "Until dispelled",
  "description": [
    "You touch a closed door, window, gate, chest, or other entryway, and it becomes locked for the duration.",
    "You and the creatures you designate when you cast this spell can open the object normally. You can also set a password that, when spoken within 5 feet of the object, suppresses this spell for 1 minute. Otherwise, it is impassable until it is broken or the spell is dispelled or suppressed. Casting Knock on the object suppresses Arcane Lock for 10 minutes.",
    "While affected by this spell, the object is more difficult to break or force open; the DC to break it or pick any locks on it increases by 10."
  ],
  "spellLists": ["artificer", "eldritch-knight", "wizard"]
}
